$(".product-form__cart-submit").on("click", function(){
  setTimeout(function() {
    $(".cart-popup-wrapper").removeClass("cart-popup-wrapper--hidden");
    $("span#cartloder").addClass("hide");
    $("span#addcarttext").removeClass("hide");
    $(".product-form__cart-submit").removeAttr("aria-disabled");
  }, 1000); 
});
//* Scroll Animation *//
  AOS.init({
   once: true
})
  
  $(".filtering span").click(function(){
      var galclass =  $(this).attr("data-filter");
    if(galclass=='*'){
         $(".gallert_slider .gallert_slider_inner").hide();
         $(".gallert_slider .all").show();
    }else{
        $(".gallert_slider .gallert_slider_inner").hide();
      $(".gallert_slider "+galclass).show();
        console.log(galclass);
    }
      
    });

   $('.pr_gallery_slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover:false,
      dots: false,
      arrows : true,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
      		slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
      		slidesToScroll: 1
          }
        }
      ]
    }); 
    
   
   
/*
    
$(window).scroll(function() {
      if ($(this).scrollTop() > 50){  
        $('#header').addClass("header-sticky-style");
      }
      else{
        $('#header').removeClass("header-sticky-style");
      }
    });
*/


//* Menu Toggle *//


$(".menu_toggle").click(function(){
      $("#collapsibleNavbar").addClass("navbar_panel_open");
  });
  $(".menu_close_panel").click(function(){
      $("#collapsibleNavbar").removeClass("navbar_panel_open");
  });



//* Banner Slider *//

$('.banner-owl').owlCarousel({
    loop:true,
    margin:0,
	dots:false,
	autoplayHoverPause:true,    
	autoplay: true,
    slideTransition: 'linear',
    autoplaySpeed: 1000,
    smartSpeed: 3000,
    responsive:{
        0:{
            items:5
        },
        600:{
            items:5
        },
        1000:{
            items:5
        }
    }
	
});

//* Tryout Slider *//

$('.home-product-slider').owlCarousel({
    loop:true,
    margin:20,
	autoplay:true,
    nav:true,
	dots:false,
	autoplayHoverPause:true,
    slideTransition: 'linear',
    autoplaySpeed: 1000,	
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:4
        }
    }
});

//* About Slider *//

$('.about-slider').owlCarousel({
    center: true,
    loop:true,
    margin:0,
	autoplay:true,
    nav:true,
	dots:false,
	autoplayHoverPause:true,
    slideTransition: 'linear',
    autoplayTimeout : 4000,
    smartSpeed: 2000,	
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:2
        }
    }
});

/* Story Slider */

$('.story-slider').owlCarousel({
    loop:true,
    margin:20,
    nav:true,
	dots:false,
    slideTransition: 'linear',
    responsive:{
        0:{
            items:1,
            autoplay:false
        },
        600:{
            items:1
        },
        992:{
            items:1
        },
        1199:{
            items:2
        }
    }
});

//* gallery Slider *//

$('.gallery-slider').owlCarousel({
    loop:true,
    margin:10,
	dots:false,
	nav:true,
	items:1,
	autoplayHoverPause:true,    
	autoplay: true,
    slideTransition: 'linear',
    autoplaySpeed: 1000,
    smartSpeed: 1000,
});











 // testimonial
 
 $('.testimonial-slider').owlCarousel({
    loop:true,
    items:1,
    margin:10,
    dots:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
})
 
 
 
/*
$('.testimonial-slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.testimonial-slider-nav'
});
$('.testimonial-slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.testimonial-slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: false,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    }
    ]
});
*/
/* Filter Tab */

$(function(){
    $(".filtering").on("click", "span", function () {
        var a = $(".gallery").isotope({});
        var e = $(this).attr("data-filter");
        a.isotope({ filter: e });
    });
    $(".filtering").on("click", "span", function () {
        $(this).addClass("active").siblings().removeClass("active");
    });
})


//* Scroll To Top *//

//Get the button
var mybutton = document.getElementById("scroll");

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}


//* FAQ *//

const accItems = document.querySelectorAll(".accordion__item");


accItems.forEach((acc) => acc.addEventListener("click", toggleAcc));

function toggleAcc() {
  accItems.forEach((item) =>
    item != this ? item.classList.remove("accordion__item--active") : null
  );
  if (this.classList != "accordion__item--active") {
    this.classList.toggle("accordion__item--active");
  }
}
